import React, { useState } from "react";
import Skeleton from "./Skeleton";
import IrregularItemView from "./IrregularItemView";
import { IProject } from "../../store/feedStoreTypes";
import { convertCount } from "../../utils/convert";
import { useStore } from "../../store";
import { firebaseEvent, getSelectProjectType } from "../../utils/firebaseEvent";

export interface Props {
  groupKey: number;
  project: IProject;
  languageCode: string;
  onClickItem: (id: string) => void;
}

const IrregularItem = ({ project, languageCode, onClickItem }: Props) => {
  const {
    sessionStorage,
    location: { pathname },
  } = window;

  const {
    searchStore: { currentSearchState },
  } = useStore();

  const {
    ratio,
    projectId,
    imagePath,
    translation: { title },
    likeCounts,
    downloadCounts,
  } = project;

  const [isLoad, setIsLoad] = useState(false);
  const [src, setSrc] = useState(Skeleton(ratio, imagePath));

  // IntersectionObserver를 이용하여 placeholder src를 thumbnail src로 교체한다.
  const onLoad = (e: React.SyntheticEvent<HTMLDivElement, Event>) => {
    const target = e.currentTarget;
    const srcObserver = new IntersectionObserver(
      ([{ isIntersecting }]) => {
        if (isIntersecting) {
          setIsLoad(true);
          setSrc(imagePath);
          srcObserver.unobserve(target);
        }
      },
      { rootMargin: "-20px 0px" }
    );

    // Grid UI가 원인 인듯 한데, UI 배치전에 Intersection Observer가 등록되고
    // Grid UI가 배치되는 경우 화면에 잡힌 observer의 isIntersecting이 false로 반환되는 이슈가 있음
    // 임시 조치로 0.3초 간격으로 observe를 등록하게함
    setTimeout(() => srcObserver.observe(target), 300);
  };

  const onClick = () => {
    // image load 시 click 방지
    if (!isLoad) return null;
    //Firebase Event
    const jsonParams = {
      P1: projectId,
    };
    if (getSelectProjectType() === "home") {
      firebaseEvent("home_select_project", jsonParams);
    } else if (getSelectProjectType() === "search") {
      firebaseEvent("search_select_project", {
        ...jsonParams,
        P2: currentSearchState.inputValue,
        P3: currentSearchState.searchValue,
      });
    } else if (getSelectProjectType() === "hashtag") {
      firebaseEvent("hashtag_select_project", {
        ...jsonParams,
        P2: currentSearchState.searchValue,
      });
    }

    const posKey = encodeURI(`pos_${pathname}`);
    sessionStorage.setItem(posKey, projectId);
    onClickItem(projectId);
  };

  const count = {
    like: convertCount(likeCounts),
    download: convertCount(downloadCounts),
  };

  const viewProps = {
    src,
    title,
    ...count,
    projectId,
    languageCode,
    onClick,
    onLoad,
  };

  return <IrregularItemView {...viewProps} />;
};

export default IrregularItem;
